// Google Consent Mode v2 helpers.
// The gtag stub and default "denied" state are set inline in public/index.html
// so consent is denied BEFORE any tracker loads. This file only updates
// the state after the user makes a decision on the cookie banner.

export const CONSENT_STORAGE_KEY = "xynavero_consent_v1";

export const updateConsent = (granted) => {
  if (typeof window === "undefined") return;
  const value = granted ? "granted" : "denied";
  const payload = {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
    functionality_storage: "granted",
    security_storage: "granted",
  };
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", payload);
  }
  try {
    localStorage.setItem(
      CONSENT_STORAGE_KEY,
      JSON.stringify({ granted, savedAt: new Date().toISOString() }),
    );
  } catch (_) {
    // ignore storage errors
  }
};

export const readConsent = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
};
